import { render, staticRenderFns } from "./heading.vue?vue&type=template&id=fcf057e2&scoped=true&"
import script from "./heading.vue?vue&type=script&lang=ts&"
export * from "./heading.vue?vue&type=script&lang=ts&"
import style0 from "./heading.vue?vue&type=style&index=0&id=fcf057e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf057e2",
  null
  
)

export default component.exports